import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import "../../index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Row, Tab, Tabs } from "react-bootstrap";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
const Employeequestion2026 = ({ Employeetechid, Employeeid ,year}) => {

  const [activeTab, setActiveTab] = useState("technical");

  return (
    <>
      <Tabs
        id="appraisal-tabs"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        className="mb-3"
      >
        <Tab eventKey="technical" title="Technical" className="me-2">
          <Techdetail Employeetechid={Employeetechid} Employeeid={Employeeid}  year={year}/>
        </Tab>

        <Tab eventKey="mcq" title="MCQ">
          <Mcq Employeetechid={Employeetechid} Employeeid={Employeeid} year={year} />
        </Tab>

        <Tab eventKey="firmReview" title="Firm Review">
          <Firmdetail Employeetechid={Employeetechid} Employeeid={Employeeid}  year={year}/>
        </Tab>

        <Tab eventKey="selfReview" title="Self Review">
          <Selfreview Employeetechid={Employeetechid} Employeeid={Employeeid} year={year} />
        </Tab>
      </Tabs>
    </>
  );
};
const Firmdetail = ({ Employeeid,year }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const GetAppraisalCompany = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            empid: Employeeid,
            year: year,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetFirmReviewTechQa`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setQuestions(data.data);
        setFilteredQuestions(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
  const GetAllQuestionAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: Employeeid,
          type: "4", 
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setAnswers(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    if (searchTerm) {
      setFilteredQuestions(
        questions.filter((q) =>
          q.question_text.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setFilteredQuestions(questions);
    }
  }, [searchTerm, questions]);
  const formatAnswer = (answer) => {
    if (!answer) return null;
    const points = answer.split(/\d\)/).filter((point) => point.trim() !== "");
    return (
      <ul>
        {points.map((point, index) => (
          <li key={index}>{point.trim()}</li>
        ))}
      </ul>
    );
  };
  useEffect(() => {
    GetAppraisalCompany();
    GetAllQuestionAnswer();
  }, []);
  return (
    <>
      {/* <input
            type="text"
            placeholder="Search by question..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginBottom: "10px", padding: "5px", width: "300px" }}
          /> */}
      <div>
        {filteredQuestions.map((question) => {
         const answer = answers.find(
            (ans) => ans.question_id === question.rowNumber
          );
          return (
            <div key={question.question_id} style={{ marginBottom: "15px" }}>
              <p className="mb-2" style={{ fontWeight: "bold" }}>
                {question.question}
              </p>
              <p>
                <strong>Answer:</strong>
                {answer
                  ? formatAnswer(answer.answer)
                  : "No answer provided"}
              </p>
            </div>
          );
        })}
      </div>
    </>
  );
};
const Techdetail = ({ year, Employeeid }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const GetAppraisalCompany = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            empId: Employeeid,
            year: year,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetTechQa`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setQuestions(data.data);
        setFilteredQuestions(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
  const GetAllQuestionAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: Employeeid,
          type: "2", 
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setAnswers(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    if (searchTerm) {
      setFilteredQuestions(
        questions.filter((q) =>
          q.question_text.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setFilteredQuestions(questions);
    }
  }, [searchTerm, questions]);
  const formatAnswer = (answer) => {
    if (!answer) return null;
  
    const points = answer.split(/\d\)/).filter((point) => point.trim() !== "");
  
    return (
      <ul>
        {points.map((point, index) => {
          const words = point.trim().split(/\s+/); // split by any whitespace
  
          // Group words into arrays of 20 words each
          const chunks = [];
          for (let i = 0; i < words.length; i += 15) {
            chunks.push(words.slice(i, i + 15).join(" "));
          }
  
          return (
            <li key={index}>
              {chunks.map((chunk, i) => (
                <React.Fragment key={i}>
                  {chunk}
                  {i < chunks.length - 1 && <br />}
                </React.Fragment>
              ))}
            </li>
          );
        })}
      </ul>
    );
  };
  
  useEffect(() => {
    GetAppraisalCompany();
    GetAllQuestionAnswer();
  }, []);
  return (
    <>
      {/* <input
          type="text"
          placeholder="Search by question..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: "10px", padding: "5px", width: "300px" }}
        /> */}
      <div className="">
      {filteredQuestions.map((question) => {
  const answer = answers.find(
    (ans) => ans.question_id === question.rowNumber
  );
          return (
            <div key={question.question_id} style={{ marginBottom: "15px" }}>
              <p className="mb-2" style={{ fontWeight: "bold" }}>
              {question.question}
              </p>
              <p>
                <strong>Answer:</strong>
                {answer
                  ? formatAnswer(answer.answer)
                  : "No answer provided"}
              </p>
            </div>
          );
        })}
      </div>
    </>
  );
};
const Mcq = ({ year, Employeeid }) => {
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [mcqData, setMcqData] = useState([]);
  const decodeText = (text) => {
    return decodeURIComponent(text.replace(/â€™/g, "’"));
  };


  const GetAppraisalMCQ = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empId: Employeeid,
          year: year,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetMCQTechQa`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        setMcqData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
 const [selectedAnswers, setSelectedAnswers] = useState({});

  const handleOptionChange = (questionId, selectedOption) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: selectedOption,
    }));
  };
  const GetAllQuestionAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
  
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: Employeeid,
          type: "1",
        }),
      };
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        requestOptions
      );
      const data = await res.json();
  
      if (data.status === "0" && data.data) {
        const answers = {};
  
        data.data.forEach((item) => {
          answers[item.question_id] = item.answer.toUpperCase();
        });
  
        setSelectedAnswers(answers);
      }
  
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ answers:", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    GetAppraisalMCQ();
    GetAllQuestionAnswer();
  }, []);
  return (
    <div className="m-2">

        <div className="">
          <div>
            {mcqData.length > 0 ? (
              mcqData.map((question, index) =>
                index % 2 === 0 ? (
                  <div className="row pb-0 pt-0" key={question.rowNumber}>
                    {/* First Question */}
                    <div className="col-md-6 p-2">
                      <label
                        className="form-label"
                        style={{ fontSize: ".9rem" }}
                      >
                        {decodeText(question.question)}
                      </label>
                      <div>
                        {["A", "B", "C", "D"].map((option, i) => (
                          <div key={i} style={{ fontSize: ".9rem" }}>
                            <input
                              type="radio"
                              name={`q${question.rowNumber}`}
                              value={option}
                              onChange={() =>
                                handleOptionChange(question.rowNumber, option)
                              }
                              checked={selectedAnswers[question.rowNumber] === option}
                            />{" "}
                            {question[`option${option}`]}
                          </div>
                        ))}
                      </div>
                    </div>

                    {mcqData[index + 1] && (
                      <div className="col-md-6 p-2">
                        <label
                          className="form-label"
                          style={{ fontSize: ".9rem" }}
                        >
                          {decodeText(mcqData[index + 1].question)}
                        </label>
                        <div>
                          {["A", "B", "C", "D"].map((option, i) => (
                            <div key={i} style={{ fontSize: ".9rem" }}>
                              <input
                                type="radio"
                                name={`q${mcqData[index + 1].rowNumber}`}
                                onChange={() =>
                                  handleOptionChange(
                                    mcqData[index + 1].rowNumber,
                                    option
                                  )
                                }
                                checked={
                                  selectedAnswers[mcqData[index + 1].rowNumber] === option
                                }
                              />{" "}
                             {question[`option${option}`]}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : null
              )
            ) : (
              <p>No MCQs available.</p>
            )}
          </div>
        </div>
   
    </div>
  );
};
const Selfreview = ({ Employeeid,year }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [mcqData, setMcqData] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const decodeText = (text) => {
    return decodeURIComponent(text.replace(/â€™/g, "’"));
  };
  const GetAppraisalMCQSelf = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            empid: Employeeid,
            year: year,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetSelfReviewTechQa`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        setMcqData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
  const handleOptionChange = (questionId, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };
  const GetAllQuestionAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: Employeeid,
          type: "3",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0" && data.data) {
        const answers = {};
        data.data.forEach((item) => {
            answers[item.question_id] = item.answer.toUpperCase();  });
        setSelectedAnswers(answers);
      }

      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ answers:", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    GetAppraisalMCQSelf();
    GetAllQuestionAnswer();
  }, []);

  return (
    <div className="m-3">
      <h5 className="mb-0">Self Evaluation</h5>
      <div className="">
      {mcqData.map((question, index) =>
  index % 2 === 0 ? (
    <div className="row pb-0 pt-0" key={question.rowNumber}>

      {/* First Question */}
      <div className="col-md-6 p-2">
        <label className="form-label" style={{ fontSize: ".9rem" }}>
          {decodeText(question.question)}
        </label>

        <div>
          {["A", "B", "C", "D"].map((option, i) => (
            <div key={i}>
              <input className="mx-2"
                type="radio"
                name={`q${question.rowNumber}`}
                value={option}
                onChange={() =>
                  handleOptionChange(question.rowNumber, option)
                }
                checked={
                  selectedAnswers[question.rowNumber] === option
                }
              />
              {question[`option${option}`]}
            </div>
          ))}
        </div>
      </div>

      {mcqData[index + 1] && (
        <div className="col-md-6 p-2">
          <label className="form-label" style={{ fontSize: ".9rem" }}>
            {decodeText(mcqData[index + 1].question)}
          </label>

          <div>
            {["A", "B", "C", "D"].map((option, i) => (
              <div key={i}>
                <input className="mx-2"
                  type="radio"
                  name={`q${mcqData[index + 1].rowNumber}`}
                  value={option}
                  onChange={() =>
                    handleOptionChange(
                      mcqData[index + 1].rowNumber,
                      option
                    )
                  }
                  checked={
                    selectedAnswers[
                      mcqData[index + 1].rowNumber
                    ] === option
                  }
                />
                {mcqData[index + 1][`option${option}`]}
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  ) : null
)}
      </div>
    </div>
  );
};
export default Employeequestion2026;
